
import { Ba1300Class } from '../ba1300/ba1300-class';
import { Adm0006Class } from '../ADM0006/adm0006-class';
import { Ba1160Class } from '../ba1160/ba1160-class';
import { Ba1400Class } from '../ba1400/ba1400-class';
import { Da1020Class } from '../da1020/da1020-class';
import { Adm0002Class } from '../ADM0002/adm0002-class';

export class WIDGET0004Class {
    AnnouncementId : number; 
    Title : string;
    Messages : number;
    EmailRequires: number;   
    DisplayTill : Date;  
    EmployeeList:  Array<Ba1300Class> = [];
    StrDateTill:string;

    RecStatus:string;
    CrtdBy: number;
    MdfdOn: Date;

    LeaveStartDate:Date;
    LeaveEndDate:Date;
    FkCompId:number;
    CompNam:string;
    UserNam:string;

    FkDateFrm:Date;
    FkDateTo:Date;
   
  
}